// LogoutConfirmModal.tsx — Sprint 14. Sign-out confirmation dialog.
// Note: the dropdown's Sign Out item bypasses this modal (see
// hooks/useLogout.ts for the C1 hotfix story); this modal is kept
// for explicit-confirm entry points.
import React from 'react';
import { Button, Modal, Space, Typography } from 'antd';
import { ExclamationCircleOutlined, LogoutOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

export interface LogoutConfirmModalProps {
  open:     boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const LogoutConfirmModal: React.FC<LogoutConfirmModalProps> = ({
  open, onCancel, onConfirm,
}) => (
  <Modal
    title={<Space><LogoutOutlined style={{ color: '#f56565' }} /><span>Confirm Sign Out</span></Space>}
    open={open}
    onCancel={onCancel}
    footer={[
      <Button key="cancel" onClick={onCancel}>Cancel</Button>,
      <Button key="logout" type="primary" danger onClick={onConfirm} icon={<LogoutOutlined />}>
        Sign Out
      </Button>,
    ]}
    centered
  >
    <div style={{ textAlign: 'center', padding: '24px 0' }}>
      <ExclamationCircleOutlined style={{ fontSize: 48, color: '#f56565', marginBottom: 16 }} />
      <Title level={5} style={{ marginBottom: 8 }}>Are you sure you want to sign out?</Title>
      <Text type="secondary">
        You will be redirected to the login page. Any unsaved changes will be lost.
      </Text>
    </div>
  </Modal>
);
